import { VscGithub, VscBrowser } from 'react-icons/vsc';
import { useContext, useEffect } from 'react';
import AOS from 'aos';
import MyContext from '../context/MyContext';
import projects from '../services/projects';
import texts from '../services/texts';
import 'aos/dist/aos.css';

export default function ProjectCards() {
  const { language } = useContext(MyContext);
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    projects.map((project, index) => (
      <div
        className="project-wraper"
        data-aos="zoom-in-up"
        data-aos-duration={1000 + ((index + 1) * 300)}
        style={{ backgroundImage: `url(${project.img})` }}
      >
        <div className="project-content">
          <h4>{project.title}</h4>
          <p>{project.description[language]}</p>
          <div className="techs">
            <a href={project.github} className="links">
              <VscGithub />
              {' '}
              GitHub
            </a>
            <a href={project.deploy} className="links">
              <VscBrowser />
              {' '}
              Deploy
            </a>
          </div>
          <p className="used-techs">{texts.projects[language].tech}</p>
          <div className="techs icons">
            {project.tech.map((tech) => (
              <p>{tech}</p>
            ))}
          </div>
        </div>
      </div>
    ))
  );
}
